import React from "react";
import { Modal } from "@mui/material";

import CustomInput from "../inputs/CustomInput";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { bvnSchema } from "../../Helper/validationSchemas";
import { _countries } from "../../config/data";

import { withdrawFunds } from "../../store/actions/userManagement/withdrawFunds";
import { Box } from "@mui/system";
import { verifyBVN } from "../../store/actions/userManagement/verifyBVN";

const VerifyBVN = ({ open, onClose, userId }) => {
  const dispatch = useDispatch();

  const handleSubmit = (values, { resetForm, setSubmitting }) => {
    const payload = {
      data: {
        user_id: userId,
        BVN: values?.BVN,
      },
      cb: () => {
        onClose();
        setSubmitting(false);
      },
      failed: () => {
        resetForm();
        setSubmitting(false);
      },
    };

    dispatch(verifyBVN(payload));
  };
  const form = useFormik({
    initialValues: {
      BVN: "",
    },
    validationSchema: bvnSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          maxHeight: "80%",
          overflowY: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-5" style={{ padding: "10px 20px" }}>
          <img
            src="/Assets/approveIcon.png"
            alt=""
            className="w-12 h-12 mb-5"
          />
          <div className="w-full  my-2">
            <label className="text-sm font-[600] text-[#344054]">BVN</label>
            <div className="w-full mb-4">
              <CustomInput
                fullWidth
                id="BVN"
                type="number"
                height="12px"
                form={form}
                placeholder={"Enter BVN"}
                borderColor="#D0D5DD"
                mt="10px"
                pt="28px"
              />
            </div>

            <div className="flex w-full  items-center">
              <CustomButton
                loading={form.isSubmitting}
                variant="contained"
                customColor="#159AA8"
                children="Verify BVN"
                width="100%"
                height="55px"
                disabled={!form.dirty || !form.isValid}
                padding="10px"
                margin="50px 0 15px"
                color="#fff"
                onClick={form.handleSubmit}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default VerifyBVN;
